import request from '@/utils/request'

// 查询分页
export function fetchList (data) {
  return request.post('/template/parameter/page', data)
}

// 新建
export function create (data) {
  return request.post('/template/parameter/create', data)
}

// 编辑
export function updateById (data) {
  return request.post('/template/parameter/updateById', data, {
    trim: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/template/parameter/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/template/parameter/delete/batch', {
    params: {
      ids
    }
  })
}
